import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AbstractDashboardDto, DocumentDto, MsisdnDto, PartnerDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpDashboardService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/dashboard', authService);
	}

	getData(startDate: string, endDate: string, partner?: PartnerDto): Observable<AbstractDashboardDto[]> {
		return super.doGet(true, `/?startDate=${startDate}&endDate=${endDate}&partnerId=${partner?.id??''}`);
	}
	getAvailablePartners(): Observable<PartnerDto[]> {
		return super.doGet(true, `/partners`);
	}

}
